__turbopack_context__.v({
  "compare": "editing-module__O-9ZFa__compare",
  "comparePlay": "editing-module__O-9ZFa__comparePlay",
  "compareRefs": "editing-module__O-9ZFa__compareRefs",
  "compareTabs": "editing-module__O-9ZFa__compareTabs",
  "credit": "editing-module__O-9ZFa__credit",
  "engine": "editing-module__O-9ZFa__engine",
  "engineFacts": "editing-module__O-9ZFa__engineFacts",
  "enginePrice": "editing-module__O-9ZFa__enginePrice",
  "engines": "editing-module__O-9ZFa__engines",
  "example": "editing-module__O-9ZFa__example",
  "exampleTag": "editing-module__O-9ZFa__exampleTag",
  "examples": "editing-module__O-9ZFa__examples",
  "examplesGrid": "editing-module__O-9ZFa__examplesGrid",
  "heroInstruction": "editing-module__O-9ZFa__heroInstruction",
});
